export default class WorkorderModel {
    id: number;
    cms_users_id_issued_by: number;
    work_orders_no: string;
    ticket_id: number;
    title: string;
    ref_regions_id: number;
    fl_code: string;
    activity_maintenance_id: number;
    equipment_id: number;
    bom: string;
    description: string;
    work_center_id: number;
    is_refurbished: number;
    is_require_material: number;
    priority: string;
    scope_of_works: any[];
    status: string;
    status_simplify: string;
    status_color: string;
    reason: string;
    attachments: any[];
    deleted_at: string | null;
    created_at: string;
    updated_at: string;
    technicians: any[];
    activitymaintenance: any;
    workcenter: any;
    materials: any[];
    equipment: any;

    constructor(data: any = {}) {
        this.id = data.id || 0;
        this.cms_users_id_issued_by = data.cms_users_id_issued_by || 0;
        this.work_orders_no = data.work_orders_no || "";
        this.ticket_id = data.ticket_id || 0;
        this.title = data.title || "";
        this.ref_regions_id = data.ref_regions_id || 0;
        this.fl_code = data.fl_code || "";
        this.activity_maintenance_id = data.activity_maintenance_id || 0;
        this.equipment_id = data.equipment_id || 0;
        this.bom = data.bom || "";
        this.description = data.description || "";
        this.work_center_id = data.work_center_id || 0;
        this.is_refurbished = data.is_refurbished || 0;
        this.is_require_material = data.is_require_material || 0;
        this.priority = data.priority || "";
        this.scope_of_works = data.scope_of_works || [];
        this.status = data.status || "";
        this.status_simplify = data.status_simplify || "";
        this.status_color = data.status_color || "";
        this.reason = data.reason || "";
        this.attachments = data.attachments || [];
        this.deleted_at = data.deleted_at || null;
        this.created_at = data.created_at || "";
        this.updated_at = data.updated_at || "";
        this.technicians = data.technicians || [];
        this.activitymaintenance = data.activitymaintenance || {};
        this.workcenter = data.workcenter || {};
        this.materials = data.materials || [];
        this.equipment = data.equipment || {};
    }
}

